import config from 'config'
import RoutingMenu from 'LIBRARY/CommonResources/RoutingMenu/RoutingMenu'
import React from 'react'
import "./Rules.css"

export const Rules = () => {
  return (
    <>
      <RoutingMenu activeScreen="rules" />
      <div className=''>

        <h6 className='ruleContainer d-flex justify-content-center align-self-center'>Please note that the rules and policies have been moved to settings. Additionally, you will now find holidays and week offs alongside the rules.
        </h6>
        {/* <iframe
                src={`${config.RootUrl}/faculty/library/rules/rulesHTML.php?isIframe=true`}
                className="iframe col-md-12"
            >
            </iframe> */}
      </div>
    </>
  )
}
